<template>
  <section class="diagnostics" ref="diagnosticList">
    <div v-if="getListLoading || getListError">
      <Loader :loading="getListLoading" :error="!!getListError" />
    </div>
    <template v-else>
      <DiagnosticsFilter
        :initState="filters"
        @submit="submitFilters"
        @reset="resetFilter"
        @reset-all-filters="resetAllFilters"
      />
      <MainSorting @update="updateSorting" :initState="sorting" />
      <EmptyData
        v-if="!getDiagnosticsData.length"
        :title="'Мы ничего не нашли по заданным параметрам'"
      />
      <template v-else>
        <AnalysisListCard
          v-for="(diagnostic, i) of getDiagnosticsData"
          :analysis="diagnostic"
          :isDiagnostic="true"
          :key="diagnostic.id + i"
          @click="() => handleCardClick(diagnostic.id)"
        />
      </template>

      <Pagination
        v-if="getDiagnosticsData.length"
        :paginationInfo="paginationInfo"
        :getData="getFilteredData"
        :getMoreData="(payload) => getFilteredData({ merge: true, ...payload })"
        :autoLoad="false"
      >
      </Pagination>
    </template>
  </section>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

import DiagnosticsFilter from '@/components/smFilters/DiagnosticsFilter'
import AnalysisListCard from '@/components/analysisListCard'
import Pagination from '@/components/pagination/pagination'
import MainSorting from '@/components/mainSorting'
import EmptyData from '@/components/emptyData'
import Loader from '@/components/loader'

import EllipseIcon from '@/assets/icons/ellipse'

import { TRACKER_SLUGS } from '@/models/tracker'
import { omitByNull } from '@/core/utils'

export default {
  name: 'Diagnostics',
  components: {
    DiagnosticsFilter,
    AnalysisListCard,
    EllipseIcon,
    MainSorting,
    Pagination,
    EmptyData,
    Loader
  },
  data() {
    return {
      filters: {
        specialityIds: null,
        from: null,
        to: null,
        dates: null,
        sort: 'DATETIME,asc'
      },
      sorting: [
        {
          id: 'DATETIME',
          name: 'По дате',
          selected: true,
          direction: 'asc'
        }
      ]
    }
  },
  async created() {
    await this.getDiagnostics({
      page: (Number(this.$route.query.page) || 1) - 1,
      size: Number(this.$route.query.size) || 5
    })
  },
  setup() {
    function resetPage() {
      if (Number(this.$route.query.page) !== 0) {
        this.$router.push({ query: { page: '0' } })
      }
    }

    function submitFilters(payload) {
      switch (payload.id) {
        case 'dates':
          if (payload.value.calendarMode === 'range') {
            this.filters.from = `${payload.value.value.start}T10:26:52.398Z`
            this.filters.to = `${payload.value.value.end}T10:26:52.398Z`
            this.filters.dates = null
          }

          if (payload.value.calendarMode === 'mulitiple') {
            this.filters.from = null
            this.filters.to = null
            this.filters.dates = payload.value.value
          }

          break
        default:
          this.filters[payload.id] = payload.value
      }

      resetPage.apply(this)
      this.getFilteredData()
    }

    function resetFilter(type) {
      switch (type) {
        case 'dates':
          this.filters.to = null
          this.filters.from = null
          this.filters.dates = null
          break
        default:
          this.filters[type] = null
      }

      resetPage.apply(this)
      this.getFilteredData()
    }

    function resetAllFilters() {
      for (const key in this.filters) {
        if (key === 'sort') continue
        this.filters[key] = null
      }

      resetPage.apply(this)
      this.getFilteredData()
    }

    function updateSorting(id, direction) {
      this.filters.sort = id
      this.sorting = this.sorting.map((s) => {
        if (s.id === id) {
          if (s.selected) {
            this.filters.sort = `${id},${direction}`
            return {
              ...s,
              direction
            }
          } else {
            return {
              ...s,
              selected: true
            }
          }
        }

        return {
          ...s,
          selected: false
        }
      })

      resetPage.apply(this)
      this.getFilteredData()
    }

    return {
      submitFilters,
      resetFilter,
      resetAllFilters,
      updateSorting
    }
  },
  methods: {
    ...mapActions('diagnostics', ['getDiagnostics', 'getFilteredDiagnostics']),
    async getFilteredData({ page, ...payload } = {}) {
      if (!payload.merge) {
        window.scrollTo(0, 0)
      }
      const filters = omitByNull(this.filters)
      await this.getFilteredDiagnostics({
        page: page ?? 0,
        size: Number(this.$route.query.size) || 5,
        ...payload,
        ...filters,
        specialityId: filters.specialityIds
      })
    },
    handleCardClick(id) {
      this.$tracker(TRACKER_SLUGS.PROCEED_DIAGNOSTIC_RESULT)
      this.$router.push({
        name: 'DiagnosticsInfo',
        query: { id }
      })
    }
  },
  computed: {
    ...mapGetters('diagnostics', [
      'getDiagnosticsData',
      'getListLoading',
      'getListError',
      'paginationInfo'
    ])
  }
}
</script>
<style lang="scss" scoped>
@import 'style.scss';
</style>
